module.exports = __webpack_public_path__ + "media/insights-graph.75a82bdd.mp4";